import { RegionPlugin } from '@/plugins/region';

const state = () => ({
  isValid: false,
  insuranceCompany: null,
  insuranceCompanyList: []
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  insuranceCompany(state) {
    return state.insuranceCompany;
  },
  insuranceCompanyList(state) {
    const region = RegionPlugin.getRegion().toUpperCase();
    return [...state.insuranceCompanyList].sort((left, right) => {
      const leftIsCurrentRegion = left.additionalInfo?.countryCode === region ? 0 : 1;
      const rightIsCurrentRegion = right.additionalInfo?.countryCode === region ? 0 : 1;
      return leftIsCurrentRegion - rightIsCurrentRegion;
    });
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateInsuranceCompany(state, payload) {
    state.insuranceCompany = payload;
  },
  setInsuranceCompanyList(state, payload) {
    state.insuranceCompanyList = payload;
  },
  resetStore(s) {
    // Preserve insuranceCompanyList — public catalogue, not user-bound.
    s.isValid = false;
    s.insuranceCompany = null;
  }
};

const actions = {
  async loadInsuranceCompanyList({ commit, dispatch }, payload) {
    if (this.getters['forms/insuranceCompany/insuranceCompanyList'].length) {
      return;
    }

    await this.$http
      .get('/v3/lists/health_insurance_provider?region=' + payload.region, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(data => {
        commit('setInsuranceCompanyList', data.values);
      })
      .catch(err => {
        dispatch('errorModal/handleError', { error: err, code: '0x00000058' }, { root: true });
      });
  }
};

export const insuranceCompany = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
